import { expValEqualsNoExposure } from '@atlaskit/tmp-editor-statsig/exp-val-equals-no-exposure';
import { hoverDecorationCommand, removeDecorationCommand } from './pm-plugins/commands';
import decorationPlugin, { decorationStateKey, hoverDecoration, removeDecoration } from './pm-plugins/main';

/**
 * Decorations plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */
export var decorationsPlugin = function decorationsPlugin() {
  return {
    name: 'decorations',
    pmPlugins: function pmPlugins() {
      return [{
        name: 'decorationPlugin',
        plugin: function plugin() {
          return decorationPlugin();
        }
      }];
    },
    actions: {
      hoverDecoration: hoverDecoration,
      removeDecoration: removeDecoration
    },
    getSharedState: function getSharedState(editorState) {
      if (!editorState) {
        return {
          decoration: undefined
        };
      }
      return decorationStateKey.getState(editorState);
    },
    commands: {
      hoverDecoration: expValEqualsNoExposure('platform_editor_block_menu', 'isEnabled', true) ? function (_ref) {
        var nodeType = _ref.nodeType,
          add = _ref.add,
          className = _ref.className;
        return hoverDecorationCommand({
          nodeType: nodeType,
          add: add,
          className: className
        });
      } : undefined,
      removeDecoration: expValEqualsNoExposure('platform_editor_block_menu', 'isEnabled', true) ? function () {
        return removeDecorationCommand();
      } : undefined
    }
  };
};